import { Component, inject, input, output } from '@angular/core';
import { FacetModel } from '../facet.model';
import { CardItemComponent } from 'app/shared/card/card-item/card-item.component';
import { IconComponent } from 'app/shared/icon/icon.component';
import { FacetAlias } from '../facet';
import { FacetIcons } from '../facet-icons.const';
import { HttpClient } from '@angular/common/http';
import { provideNgIconLoader, withCaching } from '@ng-icons/core';

@Component({
  selector: 'app-facet-grid-compact-container',
  standalone: true,
  imports: [CardItemComponent, IconComponent],
  templateUrl: './facet-grid-compact-container.component.html',
  styleUrls: ['./facet-grid-compact-container.component.scss'],
  providers: [
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
  host: {
    class: 'grid lg:grid-cols-2 mb-4 gap-4',
  },
})
export class FacetGridCompactContainerComponent {
  isCheckbox = input(false);
  isChevronIcon = input(false);
  isDeleteIcon = input(false);
  checkedFacets = input<FacetModel[]>([]);
  facets = input.required<FacetModel[]>();
  toggle = output<FacetModel>();
  delete = output<FacetModel>();

  getFacetIcon(alias: FacetAlias): string {
    return FacetIcons[alias];
  }

  isChecked(facet: FacetModel): boolean {
    return this.checkedFacets().some((checked) => checked.id === facet.id);
  }
}
